import {Injectable} from '@angular/core';
import {Observable, throwError} from 'rxjs';
import {catchError, map} from 'rxjs/operators';
import {ProductManager} from 'src/app/data/manager/product/product.manager';
import {ProductInterface} from 'src/app/data/networking/models/shared/responses/product-response';

@Injectable({
  providedIn: 'root',
})
export class GroupViewVm {
  constructor(private productManager: ProductManager) {}

  getDiscounts(items: ProductInterface[]): Observable<ProductInterface[]> {
    const productsArray = items.map(item => ({
      id: item?.id,
      mediaDescription: item?.mediaDescription,
      fullPrice: item?.fullPrice,
      primePrice: item?.primePrice,
      offerPrice: item?.offerPrice,
      brand: item?.brand,
      categorie: item?.categorie,
      subCategory: item?.subCategory,
      applyOffer: item?.applyOffer,
      barcode: item?.barcode,
      offerDescription: item?.offerDescription,
      stock: item?.stock,
      offerText: item?.offerText,
      mediaImageUrl: item?.mediaImageUrl,
      totalStock: item?.totalStock,
      primeTextDiscount: item?.primeTextDiscount,
      primeDescription: item?.primeDescription,
      talonItemFree: item?.talonItemFree,
      talonDiscount: item?.talonDiscount,
      variants: item?.variants,
      dimensions: item?.dimensions,
      sellerAddresses: item?.sellerAddresses,
    }));

    return this.productManager.getDiscounts(productsArray).pipe(
      map((res: ProductInterface[]) => {
        const productBestOffer = this.bestOffer(res, items);
        return productBestOffer;
      }),
      catchError(error => {
        console.error('Error obteniendo descuentos:', error);
        return throwError(error);
      }),
    );
  }

  bestOffer(res: Array<ProductInterface>, items: Array<ProductInterface>): ProductInterface[] {
    return items?.map(item => {
      if (item.type === 'GROUP') return item;

      const result = res?.find(itemRes => itemRes?.id?.toString() === item?.id?.toString());

      if (result) {
        const primePrice = item?.primePrice === result?.primePrice;
        const offerPrice = item?.offerPrice === result?.offerPrice;

        if ((!primePrice || !offerPrice)) {
          item.offerPrice = result?.offerPrice;
          item.offerText = result?.offerText;
          item.offerDescription = result?.offerDescription;
          item.primeDescription = result?.primeDescription;
          item.primePrice = result?.primePrice;
          item.primeTextDiscount = result?.primeTextDiscount;
        }
      }
      return item;
    });
  }
}
